(function () {
  if (window.__cqGifts) return;
  window.__cqGifts = 1;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FRG = [67880784855151, 67880785215599];
  var DEG = [67880849277039, 67880850096239];
  var ALLG = FRG.concat(DEG);
  var MAINS = [67880774795375, 67880810119279, 67880810152047];
  var isDE = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'de';
  var MINE = isDE ? DEG : FRG;

  function post(upd) {
    return fetch(R + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: upd })
    });
  }

  // gifts only when a main product is in the cart; never the other language's gifts
  function sync(addMissing) {
    return fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var hasMain = c.items.some(function (i) { return MAINS.indexOf(i.variant_id) > -1; });
      var have = {};
      c.items.forEach(function (i) { have[i.variant_id] = 1; });
      var upd = {}, n = 0;
      ALLG.forEach(function (id) {
        var want = hasMain && MINE.indexOf(id) > -1;
        if (have[id] && !want) { upd[id] = 0; n++; }
        if (!have[id] && want && addMissing) { upd[id] = 1; n++; }
      });
      if (!n) return false;
      return post(upd).then(function () { return true; });
    }).catch(function () { return false; });
  }

  function refreshCount() {
    fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cqcct').forEach(function (e) { e.textContent = c.item_count; });
    }).catch(function () {});
  }

  function hook() {
    if (window.cqRC && !window.cqRC.__cq) {
      var orig = window.cqRC;
      var wrapped = function () { return sync(false).then(function () { return orig(); }); };
      wrapped.__cq = 1;
      window.cqRC = wrapped;
    }
  }

  // checkout: add the right gifts only if a main product is present (runs before the theme's own handler)
  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cqpay,a[href$="/checkout"],a[href*="/checkout?"],button[name="checkout"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    var href = (a.tagName === 'A' && a.getAttribute('href')) || (R.replace(/\/?$/, '/') + 'checkout');
    sync(true).then(function () { window.location.href = href; });
  }, true);

  sync(false).then(function (changed) { hook(); if (changed) refreshCount(); });
  document.addEventListener('DOMContentLoaded', hook);
  setTimeout(hook, 1500);
})();
